<template>
    <flickity :key="house.id" v-if="images.length" class="house-thumb-carousel" ref="flickity" :options="flickityOptions">
        <div v-for="(image, i) in images" :key="image" class="house-thumb-carousel__item">
            <img :src="image" alt="House Thumb">
        </div>
    </flickity>

</template>


<script>
    import Flickity from 'vue-flickity';

    export default {
        components: {
            Flickity,
        },
        props: ['house'],
        data() {
            return {
                flickityOptions: {
                    prevNextButtons: false,
                    pageDots: false,
                    freeScroll: true,
                    contain: true,
                },
                images: []
            }
        },
        mounted () {
            this.images = this.images.concat(this.house.images.main)
            this.images = this.images.concat(this.house.images.extra)
            this.images = this.images.concat(this.house.images.maps)

            this.images = this.images.filter(image => {
              return image
            })
        },
        methods: {
            prev() {
                this.$refs.flickity.previous();
            },
            next() {
                this.$refs.flickity.next();
            }
        }
    }
</script>
